import { render, staticRenderFns } from "./Deviz_consimtamant_pdf.vue?vue&type=template&id=d61a3684"
import script from "./Deviz_consimtamant_pdf.vue?vue&type=script&lang=js"
export * from "./Deviz_consimtamant_pdf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports